import { Directive, HostBinding } from '@angular/core';

@Directive({ selector: 'glxy-nav-footer, [glxyNavFooter]' })
export class GalaxyNavFooterDirective {
  @HostBinding('class') class = 'glxy-nav-footer';
}
